import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getOperatorAccountInfo, getAgencies } from "./utils";

//Create the Context
const OperatorAccountInfoContext = createContext();

//Create the Provider Component
export const OperatorAccountInfoProvider = ({ children }) => {
  const [operatorAccountInfo, setOperatorAccountInfo] = useState(null);
  const [reload, setReload] = useState(true);
  const [agencies, setAgencies] = useState(null);
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [authenticationChecked, setAuthenticationChecked] = useState(null);

  const loadOperatorAccountInfo = useCallback(() => {
    getOperatorAccountInfo(setOperatorAccountInfo, setAuthenticationChecked);
  }, []);
  useEffect(() => {
    loadOperatorAccountInfo();
    getAgencies(setAgencies, setAuthenticationChecked);
    setReload(false);
  }, [reload, loadOperatorAccountInfo]);
  console.log("Agencies--->" + JSON.stringify(agencies));
  return (
    <OperatorAccountInfoContext.Provider
      value={{
        operatorAccountInfo,
        setOperatorAccountInfo,
        setReload,
        agencies,
        setAgencies,
        selectedAgency,
        setSelectedAgency,
        authenticationChecked,
        setAuthenticationChecked,
      }}
    >
      {children}
    </OperatorAccountInfoContext.Provider>
  );
};

export const useOperatorAccountInfo = () => {
  const context = useContext(OperatorAccountInfoContext);
  if (!context) {
    throw new Error(
      "useOperatorAccountInfo must used within OperatorAccountInfoProvider",
    );
  }
  return context;
};
